/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const clinicShellClinicIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const clinicShellErrorsLast24hMin = 0
export const clinicShellErrorsLast24hMax = 9007199254740991

export const clinicShellImpersonationOneClinicIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const clinicShellImpersonationOneEndedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const clinicShellImpersonationOneExpiresAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const clinicShellImpersonationOneIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const clinicShellImpersonationOneStartedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const clinicShellPfLastHeartbeatAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)

export const ClinicShell = zod.object({
  clinic: zod.object({
    bookingLinkBase: zod.string(),
    embedScriptUrl: zod.string(),
    id: zod.uuid().regex(clinicShellClinicIdRegExp),
    name: zod.string(),
    slug: zod.string(),
    status: zod.enum(['active', 'inactive']),
    timeZone: zod.string(),
  }),
  errorsLast24h: zod.int().min(clinicShellErrorsLast24hMin).max(clinicShellErrorsLast24hMax),
  impersonation: zod.union([
    zod.object({
      clinic: zod.object({
        id: zod.uuid().regex(clinicShellImpersonationOneClinicIdRegExp),
        name: zod.string(),
        slug: zod.string(),
        status: zod.enum(['active', 'inactive']),
      }),
      endedAt: zod.union([
        zod.iso.datetime({ offset: true }).regex(clinicShellImpersonationOneEndedAtOneRegExp),
        zod.null(),
      ]),
      expiresAt: zod.iso.datetime({ offset: true }).regex(clinicShellImpersonationOneExpiresAtRegExp),
      id: zod.uuid().regex(clinicShellImpersonationOneIdRegExp),
      startedAt: zod.iso.datetime({ offset: true }).regex(clinicShellImpersonationOneStartedAtRegExp),
    }),
    zod.null(),
  ]),
  pf: zod.object({
    degradedReason: zod.string().nullable(),
    lastHeartbeatAt: zod.union([
      zod.iso.datetime({ offset: true }).regex(clinicShellPfLastHeartbeatAtOneRegExp),
      zod.null(),
    ]),
    pfKeeperApp: zod.enum(['up', 'degraded', 'down', 'unknown']),
    pfSession: zod.enum(['up', 'degraded', 'down', 'unknown']),
    status: zod.enum(['healthy', 'degraded', 'down', 'unknown', 'not_connected', 'inactive']),
  }),
  role: zod.enum(['admin', 'user']),
})

export type ClinicShell = zod.input<typeof ClinicShell>
export type ClinicShellOutput = zod.output<typeof ClinicShell>
